import { z } from 'zod';

const purchaseItemSchema = z.object({
  medicineId: z.string().min(1, 'Medicine is required'),
  batchNo: z.string().min(1, 'Batch number is required'),
  expiryDate: z.string().min(1, 'Expiry date is required'),
  qty: z.number().min(1, 'Quantity must be greater than 0'),
  unitPrice: z.number().min(0, 'Unit price must be 0 or greater'),
  mrp: z.number().min(0, 'MRP must be 0 or greater').optional(),
});

export const purchaseSchema = z.object({
  invoiceNo: z.string().min(1, 'Invoice number is required'),
  supplierId: z.string().min(1, 'Supplier is required'),
  date: z.string().min(1, 'Date is required'),
  items: z.array(purchaseItemSchema).min(1, 'At least one item is required'),
  discount: z.number().min(0, 'Discount must be 0 or greater').optional(),
  tax: z.number().min(0, 'Tax must be 0 or greater').optional(),
  notes: z.string().optional(),
});

export type PurchaseFormData = z.infer<typeof purchaseSchema>;
export type PurchaseItemFormData = z.infer<typeof purchaseItemSchema>;
